import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Breadcrumb, BreadcrumbItem } from "../../../../src/components/breadcrumb";
import { Box } from '@twilio-paste/box';
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { Card } from '@twilio-paste/card';
import { Disclosure, DisclosureHeading, DisclosureContent } from '@twilio-paste/disclosure';
import { Grid, Column } from '@twilio-paste/grid';
import { Heading } from '@twilio-paste/heading';
import { Paragraph } from '@twilio-paste/paragraph';
import { Text } from '@twilio-paste/text';
import { useUID } from 'react-uid';
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Breadcrumb,
  BreadcrumbItem,
  Box,
  Callout,
  CalloutTitle,
  CalloutText,
  Card,
  Disclosure,
  DisclosureHeading,
  DisclosureContent,
  Grid,
  Column,
  Heading,
  Paragraph,
  Text,
  useUID,
  React
};